<template>
  <b-overlay
    :show="loading"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p>กรุณารอสักครู่...</p>
      </div>
    </template>

    <b-card>
      <b-card-title class="d-flex justify-content-between align-items-center flex-wrap">
        <span>โปรโมชั่นรายชั่วโมง</span>
        <b-button
          variant="gradient-primary"
          :disabled="saving"
          @click="saveSettings"
        >
          บันทึกทั้งหมด
        </b-button>
      </b-card-title>

      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="เปิด/ปิดระบบ">
              <b-form-checkbox
                v-model="form.is_enabled"
                switch
                class="custom-control-primary"
              >
                {{ form.is_enabled ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="ชื่อโปรโมชั่น">
              <b-form-input
                v-model="form.title"
                placeholder="โปรโมชั่นรายชั่วโมง"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="จำนวนยูสลูกค้าที่รับได้ต่อวัน">
              <b-form-input
                v-model.number="form.daily_claim_limit"
                type="number"
                min="0"
                step="1"
                placeholder="0"
              />
              <small class="text-muted">0 = รับไม่ได้</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="จำนวนลูกค้าที่รับโปรวันนี้">
              <b-form-input
                :value="formatInt(claimed_count_today)"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="ขั้นต่ำยอดฝากรวมที่รับโปรได้ (บาท)">
              <b-form-input
                v-model.number="form.min_deposit_amount"
                type="number"
                min="0"
                step="1"
                placeholder="200"
              />
              <small class="text-muted">นับยอดฝากสำเร็จสะสมตั้งแต่สมัคร · 0 = ไม่กำหนดขั้นต่ำ (ต้องเคยฝากอย่างน้อย 1 ครั้ง)</small>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="รายละเอียด">
              <b-form-textarea
                v-model="form.description"
                rows="2"
                placeholder="รายละเอียดโปรโมชั่น"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-table
        striped
        hover
        responsive
        :items="form.tiers"
        :fields="fields"
      >
        <template #cell(bonus_amount)="data">
          {{ data.item.bonus_amount }} เครดิต
        </template>

        <template #cell(is_enabled)="data">
          <b-form-checkbox
            v-model="data.item.is_enabled"
            switch
            class="custom-control-primary"
          />
        </template>

        <template #cell(turn_multiplier)="data">
          <b-form-input
            v-model.number="data.item.turn_multiplier"
            type="number"
            min="0"
            step="1"
          />
        </template>

        <template #cell(max_withdraw_multiplier)="data">
          <b-form-input
            v-model.number="data.item.max_withdraw_multiplier"
            type="number"
            min="0"
            step="1"
          />
        </template>
      </b-table>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BIconController,
  BCard,
  BCardTitle,
  BCardBody,
  BTable,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'

const DEFAULT_TIERS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((bonus_amount, index) => ({
  bonus_amount,
  is_enabled: false,
  turn_multiplier: 5,
  max_withdraw_multiplier: 3,
  sort_order: index + 1,
}))

export default {
  components: {
    BOverlay,
    BIconController,
    BCard,
    BCardTitle,
    BCardBody,
    BTable,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
  },
  data() {
    return {
      loading: false,
      saving: false,
      claimed_count_today: 0,
      form: {
        is_enabled: false,
        title: 'โปรโมชั่นรายชั่วโมง',
        description: '',
        daily_claim_limit: 0,
        min_deposit_amount: 200,
        tiers: JSON.parse(JSON.stringify(DEFAULT_TIERS)),
      },
      fields: [
        { key: 'bonus_amount', label: 'ยอดโบนัส' },
        { key: 'is_enabled', label: 'เปิด/ปิด' },
        { key: 'turn_multiplier', label: 'เทิร์น (เท่า)' },
        { key: 'max_withdraw_multiplier', label: 'ถอนสูงสุด (เท่า)' },
      ],
    }
  },
  mounted() {
    this.fetchSettings()
  },
  methods: {
    async fetchSettings() {
      this.loading = true
      try {
        const { data } = await this.$http.get('/hourly-promotion/show')
        const setting = data?.data || {}
        this.form.is_enabled = !!setting.is_enabled
        this.form.title = setting.title || 'โปรโมชั่นรายชั่วโมง'
        this.form.description = setting.description || ''
        this.form.daily_claim_limit = Number(setting.daily_claim_limit || 0)
        this.form.min_deposit_amount = setting.min_deposit_amount == null ? 200 : Number(setting.min_deposit_amount)
        this.claimed_count_today = Number(setting.claimed_count_today || 0)
        this.form.tiers = this.mergeTiers(setting.tiers || [])
      } catch (error) {
        this.SwalError(error?.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ')
      } finally {
        this.loading = false
      }
    },
    mergeTiers(tiers) {
      const byAmount = new Map(tiers.map(tier => [Number(tier.bonus_amount), tier]))
      return DEFAULT_TIERS.map((defaultTier) => {
        const tier = byAmount.get(defaultTier.bonus_amount) || {}
        return {
          ...defaultTier,
          ...tier,
          bonus_amount: defaultTier.bonus_amount,
        }
      })
    },
    formatInt(value) {
      return Number(value || 0).toLocaleString('en-US')
    },
    async saveSettings() {
      this.saving = true
      try {
        const payload = {
          is_enabled: this.form.is_enabled,
          title: this.form.title,
          description: this.form.description,
          daily_claim_limit: Math.max(0, Number(this.form.daily_claim_limit || 0)),
          min_deposit_amount: Math.max(0, Number(this.form.min_deposit_amount || 0)),
          tiers: this.form.tiers.map(tier => ({
            bonus_amount: tier.bonus_amount,
            is_enabled: !!tier.is_enabled,
            turn_multiplier: Number(tier.turn_multiplier || 0),
            max_withdraw_multiplier: Number(tier.max_withdraw_multiplier || 0),
            sort_order: tier.sort_order,
          })),
        }
        const { data } = await this.$http.post('/hourly-promotion/update', payload)
        if (data?.data) {
          this.form.tiers = this.mergeTiers(data.data.tiers || [])
        }
        this.Success('บันทึกการตั้งค่าสำเร็จ')
      } catch (error) {
        this.SwalError(error?.response?.data?.message || 'บันทึกไม่สำเร็จ')
      } finally {
        this.saving = false
      }
    },
    Success(mes) {
      this.$swal({
        title: 'สำเร็จ',
        text: mes,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    SwalError(mes) {
      this.$swal({
        title: 'Error',
        text: mes,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
  },
}
</script>
